import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { TextForm } from '../text';
export class LongTextForm extends React.PureComponent {
    render() {
        return _jsx(TextForm, { ...this.props, isLong: true });
    }
}
//# sourceMappingURL=form.js.map